import { useState } from "react";
import { api, formatApiError } from "@/lib/api";

export default function LoginScreen({ onAuthed }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("gg_token", data.token);
      onAuthed();
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#090909] text-[#F2EFEB] flex items-center justify-center px-4 font-mono-ui">
      <form onSubmit={login} data-testid="admin-login-form" className="w-full max-w-md border-2 border-[#F2EFEB] p-8">
        <p className="overline text-[#DFFF00] mb-2">Good Grief / Terminal</p>
        <h1 className="font-display text-5xl mb-8 leading-none">ADMIN<br />ACCESS</h1>
        <label className="overline block mb-2">Email</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input"
          className="w-full bg-transparent border-b-2 border-[#F2EFEB] h-12 mb-6 px-1 focus:outline-none focus:border-[#DFFF00]" required />
        <label className="overline block mb-2">Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input"
          className="w-full bg-transparent border-b-2 border-[#F2EFEB] h-12 mb-6 px-1 focus:outline-none focus:border-[#DFFF00]" required />
        {error && <p data-testid="admin-login-error" className="text-[#FF2A00] text-sm mb-4">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-btn"
          className="w-full h-12 border-2 border-[#F2EFEB] bg-[#F2EFEB] text-[#090909] uppercase tracking-widest text-sm hover:bg-[#DFFF00] hover:border-[#DFFF00] transition-colors disabled:opacity-60">
          {loading ? "..." : "Enter →"}
        </button>
        <a href="/" className="block mt-6 overline opacity-50 hover:opacity-100">← Back to site</a>
      </form>
    </div>
  );
}
